export const modalTypes = {
    BEFORE_CLASS: 0,
    DURING_CLASS: 1,
    AFTER_CLASS: 2,
    BETWEEN_CLASSES: 3,
};

export const displayTypes = {
    WORKOUT_EXERCISES: 0,
    WEARABLE_STATS: 1,
    WORKOUT_PLAYBACK: 2,
    GENERAL_LEADERBOARDS: 3,
    WORKOUT_LEADERBOARDS: 4,
    YOUTUBE_VIDEO: 5,
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/constants.js